import { useContext, useEffect, useState } from "react";
import { Tabs } from "antd";
import CardHeader from "../../../antd/components/CardHeader";
import FinancialOpeningsTab from "./FinancialOpeningsTab";
import FinancialStatementsTab from "./FinancialStatementsTab";
import LoansAndFinancingTab from "./LoansAndFinancingTab";
import StatutoryDocumentsTab from "./StatutoryDocumentsTab";
import { FileFinepModel } from "../../../Models/FileFinepModel";
import { useParams } from "react-router-dom";
import { GetFilesFinep } from "../../../API/FileFinepAPI";
import FinepPercentage from "../../../Components/Shared/FinepPercentage";
import { RegistrationDocumentsFinepContext } from "../../../Contexts/RegistrationDocumentsFinepContext";
import Loader from "../../../Components/Shared/Loader";

const RegistrationDocumentsFinep = () => {
    const [files, setFiles] = useState<FileFinepModel[]>([]);
    const [loading, setLoading] = useState(false);
    const { registerId } = useParams();
    const { handleChangeTab, value, validateModel, validateValue } = useContext(RegistrationDocumentsFinepContext);
    const { id } = useParams();

    async function getFiles() {
        setLoading(true);
        try {
            const result = await GetFilesFinep(registerId ?? "");
            setFiles(result.data);
        } catch {
            setLoading(false);
        }
        
        setLoading(false);
    }

    useEffect(() => {
        getFiles();
    }, []);

    const filleds = validateModel.reduce((acc, obj) => acc + obj.filledsPercentage, 0);

    const Items = [
        {
            label: "Demonstrações Financeiras",
            key: "0",
            children: <FinancialStatementsTab files={files} />,
        },
        {
            label: "Documentos Estatutários",
            key: "1",
            children: <StatutoryDocumentsTab files={files} />,
        },
        {
            label: "Aberturas Financeiras | ROB",
            key: "2",
            children: <FinancialOpeningsTab />,
        },
        {
            label: "Aberturas Financeiras | Empréstimos e Financiamentos",
            key: "3",
            children: <LoansAndFinancingTab />,
        },
    ];

    return (
        <>
            {loading && <Loader />}
            <div className='card ml-2 mr-2'>

                <CardHeader
                    pageName={"Documentos Cadastrais"}
                    hasPageBefore={true}
                    linkPageBefore={`/registrationFinep/${registerId}/${id}`}
                    pageBeforeName={"Cadastro Finep"}
                />
                <div className="card-body p-4">
                    <FinepPercentage filled={Math.floor(filleds)} validated={Math.floor(validateValue)} />
                    <Tabs 
                        activeKey={value.toString()} 
                        onChange={(key) => handleChangeTab({} as React.SyntheticEvent, Number(key))} 
                        items={Items} 
                    />
                </div>
            </div>
        </>
    );
};

export default RegistrationDocumentsFinep;